import { render, staticRenderFns } from "./EditAjustesOrigen.vue?vue&type=template&id=8271ab18&scoped=true"
import script from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
export * from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
import style0 from "./EditAjustesOrigen.vue?vue&type=style&index=0&id=8271ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271ab18",
  null
  
)

export default component.exports